import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      fill={color}
      d="M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm5.77 6.83l-5.7 7.74a.84.84 0 0 1-1.18.17h-.01L4.8 11.46a.83.83 0 0 1 1.05-1.3l3.4 2.72 5.18-7.04a.83.83 0 1 1 1.34.98z"
    />
  </svg>
);
